"use strict";

var _require = require('./helpers/request_handler'),
    init = _require.init;

var mainMethods = require('./main');

var bucketMethods = require('./bucket');

var Cosmic = function Cosmic(config) {
  init(config); // Combine methods

  var methods = {
    bucket: bucketMethods
  };
  return Object.assign(mainMethods, methods);
};

module.exports = Cosmic;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC5qcyJdLCJuYW1lcyI6WyJyZXF1aXJlIiwiaW5pdCIsIm1haW5NZXRob2RzIiwiYnVja2V0TWV0aG9kcyIsIkNvc21pYyIsImNvbmZpZyIsIm1ldGhvZHMiLCJidWNrZXQiLCJPYmplY3QiLCJhc3NpZ24iLCJtb2R1bGUiLCJleHBvcnRzIl0sIm1hcHBpbmdzIjoiOztlQUFpQkEsT0FBTyxDQUFDLDJCQUFELEM7SUFBaEJDLEksWUFBQUEsSTs7QUFDUixJQUFNQyxXQUFXLEdBQUdGLE9BQU8sQ0FBQyxRQUFELENBQTNCOztBQUNBLElBQU1HLGFBQWEsR0FBR0gsT0FBTyxDQUFDLFVBQUQsQ0FBN0I7O0FBRUEsSUFBTUksTUFBTSxHQUFHLFNBQVRBLE1BQVMsQ0FBQ0MsTUFBRCxFQUFZO0FBQ3pCSixFQUFBQSxJQUFJLENBQUNJLE1BQUQsQ0FBSixDQUR5QixDQUV6Qjs7QUFDQSxNQUFNQyxPQUFPLEdBQUc7QUFDZEMsSUFBQUEsTUFBTSxFQUFFSjtBQURNLEdBQWhCO0FBR0EsU0FBT0ssTUFBTSxDQUFDQyxNQUFQLENBQWNQLFdBQWQsRUFBMkJJLE9BQTNCLENBQVA7QUFDRCxDQVBEOztBQVNBSSxNQUFNLENBQUNDLE9BQVAsR0FBaUJQLE1BQWpCIiwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgeyBpbml0IH0gPSByZXF1aXJlKCcuL2hlbHBlcnMvcmVxdWVzdF9oYW5kbGVyJylcbmNvbnN0IG1haW5NZXRob2RzID0gcmVxdWlyZSgnLi9tYWluJylcbmNvbnN0IGJ1Y2tldE1ldGhvZHMgPSByZXF1aXJlKCcuL2J1Y2tldCcpXG5cbmNvbnN0IENvc21pYyA9IChjb25maWcpID0+IHtcbiAgaW5pdChjb25maWcpXG4gIC8vIENvbWJpbmUgbWV0aG9kc1xuICBjb25zdCBtZXRob2RzID0ge1xuICAgIGJ1Y2tldDogYnVja2V0TWV0aG9kc1xuICB9XG4gIHJldHVybiBPYmplY3QuYXNzaWduKG1haW5NZXRob2RzLCBtZXRob2RzKVxufVxuXG5tb2R1bGUuZXhwb3J0cyA9IENvc21pY1xuIl19